<template>
	<div class="search-option-wrapper">
		<span>사용유무</span>
		<div class="search-option-wrapper__normal">
			<el-select v-model="data" placeholder="사용유무" style="height: 40px">
				<el-option label="전체" value=""></el-option>
				<el-option label="Y" value="Y"></el-option>
				<el-option label="N" value="N"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		data: {
			type: String,
			default: '',
		},
	},
};
</script>

<style></style>
